import type { DialogHeaderProps } from "./types-dialog-header";
import { useDialogHeader } from "./use-dialog-header";
import { DialogHeaderView } from "./view-dialog-header";

/** Conteúdo do `header` do `Dialog` no padrão do Hub. */
export function DialogHeader(props: DialogHeaderProps) {
  const viewModel = useDialogHeader(props);

  return <DialogHeaderView {...viewModel} />;
}
DialogHeader.displayName = "DialogHeader";
